﻿import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import { AvatarSize } from "marketplace/_views/avatars/avatar-size";
import { useGetTeamAvatarQuery } from "marketplace/teams/_api/marketplace-team-api";
import { getTeamAvatar } from "marketplace/teams/_store/marketplace-teams-redux-slice";
import Team from "marketplace/teams/team";
import { useSelector } from "react-redux";

const StyledAvatar = styled(Avatar)<{ disabled?: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}));
const LoadingProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
  height: "75%",
  width: "75%",
}));

type TeamAvatarProps = {
  className?: string;
  team?: Team;
  disabled?: boolean;
  size?: AvatarSize;
};

export default function TeamAvatar(props: Readonly<TeamAvatarProps>) {
  const { className, team, disabled } = props;
  const size = props.size ?? "small";

  const base64AvatarData = useSelector(getTeamAvatar(team?.id ?? null, size));
  const { isLoading: isLoadingAvatar, isError: errorLoadingAvatar } = useGetTeamAvatarQuery(
    { teamId: team?.id.value ?? "", size },
    { skip: !team?.profile.avatarId || !!base64AvatarData || !team?.id },
  );

  return (
    <>
      {base64AvatarData ? (
        <StyledAvatar className={className} disabled={disabled} src={base64AvatarData}>
          {!base64AvatarData && isLoadingAvatar && !errorLoadingAvatar && <LoadingProgress disableShrink />}
        </StyledAvatar>
      ) : (
        <Avatar className={className} />
      )}
    </>
  );
}
